import React from 'react'
import palette from 'core-system/Themes/palette'
import Text from 'core-system/Text'
import SummaryBudget from './components/SummaryBudget'
import SummaryOptions from './components/SummaryOptions'
import SummaryContainerBox from 'features/Programs/Summary/components/SummaryContainerBox'
import { Flex } from 'core-system/Icons/Sidebar'
import { BudgetCycle } from '../Shared/types'

const BUDGET_TITLE_BY_CYCLE: Record<BudgetCycle, string> = {
  DAILY: 'Daily Budget',
  MONTHLY: 'Monthly Budget',
  QUARTERLY: 'Quarterly Budget',
  YEARLY: 'Yearly Budget',
}

interface FlexSummaryProps {
  activeOptions: {
    flex: boolean
    gas: boolean
    transit: boolean
    parking: boolean
    tolls: boolean
    rideshare: boolean
    carshare: boolean
    transportationServices: boolean
  }
  activeMerchantIds: {
    flex: string[]
    gas: string[]
    transit: string[]
    parking: string[]
    tolls: string[]
    rideshare: string[]
    carshare: string[]
    transportationServices: string[]
  }
  budget: number
  budgetCycle?: BudgetCycle
  oneTimePurchase?: boolean
  rolloverBudget?: boolean
  prorated?: boolean
}

const QtfSummary = ({
  activeOptions = {
    flex: false,
    gas: false,
    transit: false,
    parking: false,
    tolls: false,
    rideshare: false,
    carshare: false,
    transportationServices: false,
  },
  activeMerchantIds = {
    flex: [],
    gas: [],
    transit: [],
    parking: [],
    tolls: [],
    rideshare: [],
    carshare: [],
    transportationServices: [],
  },
  budget = 0,
  budgetCycle = 'MONTHLY',
  oneTimePurchase = false,
  rolloverBudget = false,
  prorated = false,
}: FlexSummaryProps) => {
  const budgetTitle = BUDGET_TITLE_BY_CYCLE[budgetCycle]
  return (
    <SummaryContainerBox title='Fuel Allowance & Other Transportation Budget'>
      <SummaryOptions
        icon={<Flex color={palette.secondary.purple600} />}
        activeOptions={[
          {
            type: 'flex',
            activeMerchantIds: activeMerchantIds.flex,
            active: activeOptions.flex,
          },
          {
            type: 'gas',
            activeMerchantIds: activeMerchantIds.gas,
            active: activeOptions.gas,
          },
          {
            type: 'transit',
            activeMerchantIds: activeMerchantIds.transit,
            active: activeOptions.transit,
          },
          {
            type: 'parking',
            activeMerchantIds: activeMerchantIds.parking,
            active: activeOptions.parking,
          },
          {
            type: 'tolls',
            activeMerchantIds: activeMerchantIds.tolls,
            active: activeOptions.tolls,
          },
          {
            type: 'rideshare',
            activeMerchantIds: activeMerchantIds.rideshare,
            active: activeOptions.rideshare,
          },
          {
            type: 'carshare',
            activeMerchantIds: activeMerchantIds.carshare,
            active: activeOptions.carshare,
          },
          {
            type: 'transportationServices',
            activeMerchantIds: activeMerchantIds.transportationServices,
            active: activeOptions.transportationServices,
          },
        ]}
      />
      <SummaryBudget
        title='Budget'
        lines={[
          {
            title: budgetTitle,
            value: budget,
          },
        ]}
      />
      {oneTimePurchase && (
        <Text variant='body2' marginTop='-0.5rem' marginBottom='1rem'>
          One-time purchase: one transaction per cycle
        </Text>
      )}
      {rolloverBudget && (
        <Text variant='body2' marginTop='-0.5rem' marginBottom='1rem'>
          Rollover unused budget: on
        </Text>
      )}
      {prorated && (
        <Text variant='body2' marginTop='-0.5rem' marginBottom='1rem'>
          Prorate budget: on
        </Text>
      )}
    </SummaryContainerBox>
  )
}

export default React.memo(QtfSummary)
